import { concat, of, EMPTY } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import moment from 'moment';

import Global from '../../../store/global-selectors';
import { buildOrdersGridRequestFiltersFromState } from '../../../orders/services/orders-grid-request-service';

import { ModalService } from 'ui-components/services/modal-service';
import { ErrorModal } from '../../../components/modals/error-modal';

import * as Api from './bulk.update.api';
import { LaunchBulkUpdateRetryModal$ } from './launch-bulk-update-retry-modal';
import * as Actions from './bulk.update.actions';

import BulkPrepayDutyAlertModal from '../../../fulfillment-planner/duties-and-taxes/bulk-alert-modal';
import { createUserSettingPrepayDutyAlert } from '../../../fulfillment-planner/duties-and-taxes/helpers';
import * as UserActions from '../../../store/user/user.actions';

export const launchValidationErrorModal$ = (validationError) => {
  ModalService.launchModal({
    component: ErrorModal,
    props: validationError,
  });
  return EMPTY;
};

export const getBulkJobData$ = (bulkUpdateJobId, filters, getState, history) => {
  const gridApiFilters = buildOrdersGridRequestFiltersFromState(getState(), filters, history?.location?.pathname);

  return Api.getBulkJobData(gridApiFilters).pipe(
    mergeMap((data) => {
      const services = Global.selectSellerExtendedServices(getState());

      // needing to filter out "undefined" right now because back end is sending ['0'] when no service is selected
      const matchingServices = data.serviceIds.map((serviceId) => services.find((sv) => sv.serviceId === serviceId)).filter((srv) => srv);
      const jobData = {
        ...data,
        services: matchingServices,
      };

      return of(Actions.requestJobDataSuccess(bulkUpdateJobId, jobData));
    }),
    catchError(() => {
      return LaunchBulkUpdateRetryModal$().pipe(mergeMap(() => getBulkJobData$(bulkUpdateJobId, filters, getState)));
    }),
  );
};

export const getBulkDutiesCount$ = ({ actionOf$, fulfillmentPlanIds, fulfillmentPlanSetId, postAcceptanceAction, state }) => {
  if (fulfillmentPlanIds?.length || fulfillmentPlanSetId) {
    return Api.getBulkDutiesCountByCost({
      fulfillmentPlanIds,
      fulfillmentPlanSetId,
    }).pipe(
      mergeMap((data) => {
        const availableDutiesOptions = data || [];

        if (availableDutiesOptions.length) {
          if (data.some((option) => !!option?.count)) {
            ModalService.launchModal({
              component: BulkPrepayDutyAlertModal,
              props: {
                availableDutiesOptions,
                fulfillmentPlanIds,
                fulfillmentPlanSetId,
                postAcceptanceAction,
              },
            });
            return EMPTY;
          }
          const setting = createUserSettingPrepayDutyAlert(state, {
            createdPrepayDutyOn: moment().toISOString(),
          });
          return concat(of(UserActions.saveUserSetting(setting)), actionOf$);
        }

        return actionOf$;
      }),
      catchError(() => actionOf$),
    );
  }

  return actionOf$;
};
